import { useAuth0 } from '@auth0/auth0-react';
import { env } from '../env';

export function useApiCallWithAuth(apiFunc: unknown) {
  const { getAccessTokenSilently, loginWithRedirect } = useAuth0();

  const request = async (...args: unknown[]) => {
    let accessToken: string;
    try {
      accessToken = await getAccessTokenSilently({
        authorizationParams: { audience: env.auth0Audience },
      });
    } catch (e) {
      // Session expired or silent auth failed — force a fresh login instead of
      // sending the request with a missing/empty token (which the API rejects with a 500).
      await loginWithRedirect();
      throw e;
    }
    return await (apiFunc as Function)(accessToken, ...args);
  };

  return { request };
}
